<script setup>
    import { ref, computed } from 'vue'

    const props = defineProps({
        ects: {
            type: String,
            required: true
        },
        allowEdit: {
            type: Boolean,
            required: false,
            default: () => false
        },
        tooltip: {
            type: String,
            required: false,
            default: () => ''
        },
        language: {
            type: String,
            required: false,
            default: () => 'deutsch'
        }
    })

    const title = computed(() => props.language === 'englisch' ? 'Credits | ECTS' : 'ECTS')

    const emit = defineEmits(['ectsSaved'])
    const editValue = ref('')

    function handleEditStart() {
        editValue.value = props.ects
    }

    function handleEditAbort() {
        editValue.value = ''
    }

    const saveEcts = () => {
        emit('ectsSaved', editValue.value)
    }
</script>

<template>
    <common-single-edit
        edit-key="ects"
        :entry="ects"
        :title="title"
        :tool-tip="tooltip"
        :allow-edit="allowEdit"
        @edit-aborted="handleEditAbort"
        @edit-started="handleEditStart"
        @text-saved="saveEcts"
    >
        <template #edit-component>
            <common-text-field v-model="editValue" density="default" class="w-100 h-100" />
        </template>
    </common-single-edit>
</template>

<script></script>

<style scoped lang="scss"></style>
